import { BubbleMenuItem } from "@/components/admin/editor/wysiwyg/bubble-menu";
import { CodeBlockSelector } from "@/components/admin/editor/wysiwyg/bubble-menu/code-block-selector";
import { ColorSelector } from "@/components/admin/editor/wysiwyg/bubble-menu/color-selector";
import { NodeSelector } from "@/components/admin/editor/wysiwyg/bubble-menu/node-selector";
import { cn } from "@/lib/utils";
import {
  BoldIcon,
  ItalicIcon,
  StrikethroughIcon,
  UnderlineIcon,
  Undo,
} from "lucide-react";
import { useState } from "react";

export default function MenuBar({ editor }) {
  const APP_ID = process.env.NEXT_PUBLIC_APP_ID;

  const [isNodeSelectorOpen, setIsNodeSelectorOpen] = useState(false);
  const [isColorSelectorOpen, setIsColorSelectorOpen] = useState(false);
  const [isCodeBlockSelectorOpen, setIsCodeBlockSelectorOpen] = useState(false);

  if (!editor) {
    return null;
  }

  const items: BubbleMenuItem[] = [
    {
      name: "bold",
      isActive: () => editor!.isActive("bold"),
      command: () => editor!.chain().focus().toggleBold().run(),
      icon: BoldIcon,
    },
    {
      name: "italic",
      isActive: () => editor!.isActive("italic"),
      command: () => editor!.chain().focus().toggleItalic().run(),
      icon: ItalicIcon,
    },
    {
      name: "underline",
      isActive: () => editor!.isActive("underline"),
      command: () => editor!.chain().focus().toggleUnderline().run(),
      icon: UnderlineIcon,
    },
    {
      name: "strike",
      isActive: () => editor!.isActive("strike"),
      command: () => editor!.chain().focus().toggleStrike().run(),
      icon: StrikethroughIcon,
    },
    {
      name: "undo",
      isActive: () => editor!.isActive("undo"),
      command: () => editor!.chain().focus().undo().run(),
      icon: Undo,
    },
  ];

  return (
    <div className="flex flex-wrap items-center justify-center">
      <NodeSelector
        editor={editor!}
        isOpen={isNodeSelectorOpen}
        setIsOpen={() => {
          setIsColorSelectorOpen(false);
          setIsCodeBlockSelectorOpen(false);
          setIsNodeSelectorOpen(!isNodeSelectorOpen);
        }}
      />
      {APP_ID === "learn" && (
        <CodeBlockSelector
          editor={editor!}
          isOpen={isCodeBlockSelectorOpen}
          setIsOpen={() => {
            setIsNodeSelectorOpen(false);
            setIsColorSelectorOpen(false);
            setIsCodeBlockSelectorOpen(!isCodeBlockSelectorOpen);
          }}
        />
      )}
      {items.map((item, index: number) => (
        <button
          key={index}
          onClick={item.command}
          className="cursor-pointer p-2 text-muted-foreground hover:bg-stone-100 active:bg-stone-200"
          type="button"
          title={item.name}
        >
          <item.icon
            className={cn("h-4 w-4", {
              "text-blue-500": item.isActive(),
            })}
          />
        </button>
      ))}
      <ColorSelector
        editor={editor!}
        isOpen={isColorSelectorOpen}
        setIsOpen={() => {
          setIsNodeSelectorOpen(false);
          setIsCodeBlockSelectorOpen(false);
          setIsColorSelectorOpen(!isColorSelectorOpen);
        }}
      />
    </div>
  );
}
